mutation UserProfileApprovalRevoke($input: UserProfileApprovalRevokeInput!) {
  userProfileApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
